import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import type { Props } from 'reactApp/ui/Mobile/OptionsModal/OptionsModal.types';

export const renderMobileOptionsModal = (data: Partial<Props>) => openPopupHelper({ popupName: popupNames.MOBILE_OPTIONS, data });
